var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkSvgrepoCom11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0.75C11.6642 0.75 12 1.08579 12 1.5V6C12 6.41421 11.6642 6.75 11.25 6.75H6.75C6.33579 6.75 6 6.41421 6 6V1.5C6 1.08579 6.33579 0.75 6.75 0.75H11.25ZM7.5 5.25H10.5V2.25H7.5V5.25Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25C16.9142 11.25 17.25 11.5858 17.25 12V16.5C17.25 16.9142 16.9142 17.25 16.5 17.25H12C11.5858 17.25 11.25 16.9142 11.25 16.5V12C11.25 11.5858 11.5858 11.25 12 11.25H16.5ZM12.75 15.75H15.75V12.75H12.75V15.75Z",
    fill: "#7E7E7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25C6.41421 11.25 6.75 11.5858 6.75 12V16.5C6.75 16.9142 6.41421 17.25 6 17.25H1.5C1.08579 17.25 0.75 16.9142 0.75 16.5V12C0.75 11.5858 1.08579 11.25 1.5 11.25H6ZM2.25 15.75H5.25V12.75H2.25V15.75Z",
    fill: "#7E7E7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12V9.75H4.5V12C4.5 12.4142 4.16421 12.75 3.75 12.75C3.33579 12.75 3 12.4142 3 12V9C3 8.58579 3.33579 8.25 3.75 8.25H8.25V6C8.25 5.58579 8.58579 5.25 9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V8.25H14.25C14.6642 8.25 15 8.58579 15 9V12C15 12.4142 14.6642 12.75 14.25 12.75C13.8358 12.75 13.5 12.4142 13.5 12Z",
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkSvgrepoCom11);
export default __webpack_public_path__ + "static/media/network-svgrepo-com (1) 1.7c9c90a2a056c1ec7557db603e2ac0f4.svg";
export { ForwardRef as ReactComponent };